import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'

export default function MenuIcon(props) {
    const { style, onClick } = props;
    const classes = useStyles(props)()

    return(
        <svg onClick={onClick} className={classes.container} style={style} width="29" height="23" viewBox="0 0 29 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="29" height="3" rx="1.5" fill="#2196C0"/>
            <rect y="10" width="29" height="3" rx="1.5" fill="#2196C0"/>
            <rect y="20" width="29" height="3" rx="1.5" fill="#2196C0"/>
        </svg>
    )
}


const useStyles = props => makeStyles((theme) => ({
    container:{
        '& rect': {
            fill: props.color,
            width: props.width,
         },
    }
}));